import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { filterDOMProps as $hvHz9$filterDOMProps } from "@react-aria/utils";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $f4b273590fab9f93$exports = {};
$parcel$export($f4b273590fab9f93$exports, "useSeparator", function () {
  return $f4b273590fab9f93$export$52210f68a14655d0;
});

function $f4b273590fab9f93$export$52210f68a14655d0(props) {
  var domProps = $hvHz9$filterDOMProps(props, {
    labelable: true
  });
  var ariaOrientation; // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
  // if it's vertical, we need to specify it

  if (props.orientation === 'vertical') ariaOrientation = 'vertical'; // hr elements implicitly have role = separator and a horizontal orientation

  if (props.elementType !== 'hr') return {
    separatorProps: _objectSpread(_objectSpread({}, domProps), {}, {
      role: 'separator',
      'aria-orientation': ariaOrientation
    })
  };
  return {
    separatorProps: domProps
  };
}

export { $f4b273590fab9f93$export$52210f68a14655d0 as useSeparator };